import { createAction, props } from '@ngrx/store';
import { ActionTypes } from './action-types';
import { AccountPointSchema, GetAccountsBaseParamsSchema } from '../../../models/account';
import { AssignTagsPayload } from '../../../bulk-operations/tags/assign-tags/assign-tags.service';
import { RemoveTagsPayload } from '../../../bulk-operations/tags/remove-tags/remove-tags.service';
import { AssignCategoryPayload } from '../../../bulk-operations/categories/assign-category/assign-category.types';
import { UpdateAccountsTypePayload } from '../../../bulk-operations/accounts/update-accounts-type/update-accounts-type.service';
import { AssignAccountResponse } from '../../../bulk-operations/accounts/assign-accounts/assign-accounts.service';
import { RemoveAccountsPayload } from '../../../bulk-operations/accounts/remove-accounts/remove-accounts.service';
import { GetAllAccountPointsContext } from './get-all-account-points.types';

export const getAllAccountPointsAction = createAction(
  ActionTypes.GET_ALL_ACCOUNT_POINTS,
  props<{ refresh: boolean, context?: GetAllAccountPointsContext, params: GetAccountsBaseParamsSchema }>()
);

export const getAllAccountPointsSuccessAction = createAction(
  ActionTypes.GET_ALL_ACCOUNT_POINTS_SUCCESS,
  props<{ accountPoints: AccountPointSchema[], context?: GetAllAccountPointsContext }>()
);

export const getAllAccountPointsFailureAction = createAction(
  ActionTypes.GET_ALL_ACCOUNT_POINTS_FAILURE,
  props<{ error: unknown, context?: GetAllAccountPointsContext }>()
);

export const clearGetAllAccountPointsV2Action = createAction(
  ActionTypes.CLEAR_GET_ALL_ACCOUNT_POINTS,
);

export const getAllAccountPointsBulkAssignTagsAction = createAction(
  ActionTypes.GET_ALL_ACCOUNT_POINTS_BULK_ASSIGN_TAGS,
  props<{ payload: AssignTagsPayload }>(),
);

export const getAllAccountPointsBulkRemoveTagsAction = createAction(
  ActionTypes.GET_ALL_ACCOUNT_POINTS_BULK_REMOVE_TAGS,
  props<{ payload: RemoveTagsPayload }>(),
);

export const getAllAccountPointsBulkAssignCategoryAction = createAction(
  ActionTypes.GET_ALL_ACCOUNT_POINTS_BULK_ASSIGN_CATEGORY,
  props<{ payload: AssignCategoryPayload }>(),
);

export const getAllAccountPointsBulkUpdateAccountsTypeAction = createAction(
  ActionTypes.GET_ALL_ACCOUNT_POINTS_BULK_UPDATE_ACCOUNTS_TYPE,
  props<{ payload: UpdateAccountsTypePayload }>(),
);

export const getAllAccountPointsBulkAssignAccountsAction = createAction(
  ActionTypes.GET_ALL_ACCOUNT_POINTS_BULK_ASSIGN_ACCOUNTS,
  props<{ payload: AssignAccountResponse[] }>(),
);

export const getAllAccountPointsBulkRemoveAccountsAction = createAction(
  ActionTypes.GET_ALL_ACCOUNT_POINTS_BULK_REMOVE_ACCOUNTS,
  props<{ payload: RemoveAccountsPayload }>(),
);
